import * as React from "react";
import { Modal, Button, Input, Form, Select } from "antd";
const FormItem = Form.Item;
import { connect } from "react-redux";
const { TextArea } = Input;
const Option = Select.Option;

interface IRefundProps {
  id: any;
  afterRefund: any;
  form: any;
  getOrderDetails: any;
  tag: any;
  type?: any;
  pfn?: any;
}

// 确认函
class Refund extends React.Component<IRefundProps, any> {
  state = {
    visible: false,
    content: '',
    refundType: '',
    refundReson: '',
    after_desc: '',
    amount: '',
    refundChannel: '',
    accountType: '',
    account: '',
    fullname: '',
  };
  constructor(props: IRefundProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }

  show(id) {
    this.setState({
      visible: true
    })
  }

  handleOk = e => {
    this.handleSubmit(e);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values['id'] = this.props.id;
        const param: any = values;
        this.props.afterRefund({
          ...param,
          callback: (data) => {
            //this.props.pfn();
            this.setState({
              visible: false
            })
            const param2: any = {
              id: this.props.id
            };
            this.props.getOrderDetails({
              ...param2,
              callback: () => { }
            });
          }
        });
      }
    });
  }

  getFormItem = () => {
    const { getFieldDecorator } = this.props.form;
    const typeRules = {
      rules: [
        {
          required: true,
          message: "请选择退款类型!"
        }
      ]
    };
    const reasonRules = {
      rules: [
        {
          required: true,
          message: "请选择退款原因!"
        }
      ]
    };
    const requireRules = {
      rules: [
        {
          required: true,
          message: "必填字段"
        }
      ]
    };
    const inputRules = {
      rules: [
        {
          required: false,
        }
      ]
    }
    const refundType = getFieldDecorator("refundType", typeRules)(
      <Select showSearch className="messge" placeholder="请选择退款类型"  >
        <Option value="退款">退款</Option>
      </Select>
    );

    const refundReson = getFieldDecorator("refundReson", reasonRules)(
      <Select showSearch className="messge" placeholder="请选择退款原因"  >
        <Option value="2">退差价</Option>
        <Option value="3">拍错/行程变更等个人原因</Option>
        <Option value="4">天气等不可抗力因素</Option>
        <Option value="5">满位、缺货</Option>
        <Option value="6">未按照约定时间发货</Option>
        <Option value="7">协商一致退款</Option>
        <Option value="8">其他</Option>
        <Option value="9">商品与描述不符</Option>
        <Option value="10">懒猫服务原因</Option>
      </Select>
    );
    const refundChannel = getFieldDecorator("refundChannel", requireRules)(
      <Select showSearch className="messge" placeholder="退款途径"  >
        <Option value="101">懒猫旅行天猫海外店支付宝</Option>
        <Option value="102">懒猫旅行天猫丽江店支付宝</Option>
        <Option value="201">懒猫hr支付宝</Option>
        <Option value="202">懒猫分公司lmfgs支付宝</Option>
        <Option value="301">上海携程智慧旅游商务咨询有限公司</Option>
        <Option value="401">北京蚂蜂窝之旅国际旅行社有限责任公司</Option>
        <Option value="501">中国银联股份有限公司浙江分公司</Option>
      </Select>
    );
    const accountType = getFieldDecorator("accountType", requireRules)(
      <Select showSearch className="messge" placeholder="用户账号类型"  >
        <Option value="支付宝">支付宝</Option>
        <Option value="银行卡">银行卡</Option>
      </Select>
    );
    const account = getFieldDecorator("account", requireRules)(
      <Input placeholder="" />
    );
    const fullname = getFieldDecorator("fullname", requireRules)(
      <Input placeholder="" />
    );
    const after_desc = getFieldDecorator("after_desc", inputRules)(
      <TextArea placeholder="描述" rows={5} />
    );

    const amount = getFieldDecorator("amount", requireRules)(
      <Input placeholder="￥" />
    );

    let list: any = [];
    list.push(
      <FormItem key="0" label="退款类型">
        {refundType}
      </FormItem>
    );
    list.push(
      <FormItem key="1" label="退款原因">
        {refundReson}
      </FormItem>
    );
    list.push(
      <FormItem key="2" label="描述">
        {after_desc}
      </FormItem>
    );
    list.push(
      <FormItem key="3" label="金额">
        {amount}
      </FormItem>
    );
    list.push(
      <FormItem key="4" label="退款途径">
        {refundChannel}
      </FormItem>
    );
    list.push(
      <FormItem key="5" label="用户账号类型">
        {accountType}
      </FormItem>
    );
    list.push(
      <FormItem key="6" label="账号">
        {account}
      </FormItem>
    );
    list.push(
      <FormItem key="7" label="姓名">
        {fullname}
      </FormItem>
    );
    return list;
  }

  render() {
    let buttonStyle;
    if (!this.props.type) {
      buttonStyle = {
        backgroundColor: "#fff",
        color: "#000",
        border: 'none',
        display: 'block',
      };
    }

    return (
      <React.Fragment>
        {this.props.tag.indexOf('5') ? <Button type="primary" style={buttonStyle} onClick={this.show.bind(this, this.props.id)}>{!this.props.type ? '退款' : '添加退款单'}</Button> : ''}
        <Modal maskClosable={false} onCancel={this.handleCancel} title="退款" visible={this.state.visible} width="auto" centered={true} onOk={this.handleOk}>
          <div className="refund">
            <Form>{this.getFormItem()}</Form>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    afterRefund: dispatch.orderDetails.afterRefund,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default Form.create<any>()(
  connect(
    mapState,
    mapDispatch
  )(Refund)
);


